import { render } from "./CustomersAdd.vue?vue&type=template&id=65515d85"
import script from "./CustomersAdd.vue?vue&type=script&lang=js"
export * from "./CustomersAdd.vue?vue&type=script&lang=js"
script.render = render

export default script